package one.healthium.insights.data.mapper

import one.healthium.insights.data.dto.IngredientDto
import one.healthium.insights.data.dto.MealPlanDataDto
import one.healthium.insights.data.dto.MealPlanDayDto
import one.healthium.insights.data.dto.NutritionDto
import one.healthium.insights.data.dto.RecipeDto
import one.healthium.insights.data.dto.ShoppingListDto
import one.healthium.insights.domain.models.IngredientModel
import one.healthium.insights.domain.models.MealPlanDayModel
import one.healthium.insights.domain.models.MealPlanModel
import one.healthium.insights.domain.models.NutritionModel
import one.healthium.insights.domain.models.RecipeModel
import one.healthium.insights.domain.models.ShoppingItemModel
import one.healthium.insights.domain.models.ShoppingItemUnitModel
import one.healthium.insights.domain.models.ShoppingListModel
import one.healthium.insights.domain.models.UnitModel

internal class MealPlanMapper {

    fun dtoToModel(dto: MealPlanDataDto): MealPlanModel = MealPlanModel(
        days = dto.weeklyMealplan.map(::mapDay),
        shoppingList = dto.shoppingList?.let(::mapShoppingList),
    )

    private fun mapDay(dto: MealPlanDayDto): MealPlanDayModel = MealPlanDayModel(
        totalCalories = dto.totalCalories,
        breakfast = dto.meals.breakfast.map(::mapRecipe),
        lunch = dto.meals.lunch.map(::mapRecipe),
        dinner = dto.meals.dinner.map(::mapRecipe),
        snack = dto.meals.snack.map(::mapRecipe),
        drink = dto.meals.drink.map(::mapRecipe),
    )

    private fun mapRecipe(dto: RecipeDto): RecipeModel = RecipeModel(
        id = dto.id,
        title = dto.title,
        emoji = dto.emoji,
        servingWeightGrams = dto.servingWeightGrams,
        ingredients = dto.ingredients.map(::mapIngredient),
        steps = dto.steps,
        nutritionPer100g = mapNutrition(dto.nutritionPer100g),
    )

    private fun mapIngredient(dto: IngredientDto): IngredientModel = IngredientModel(
        name = dto.name,
        emoji = dto.emoji,
        amount = dto.amount,
        unit = dto.unit,
    )

    private fun mapNutrition(dto: NutritionDto): NutritionModel = NutritionModel(
        calories = dto.calories,
        protein = dto.protein,
        fat = dto.fat,
        carbs = dto.carbs,
        fiber = dto.fiber,
    )

    private fun mapShoppingList(dto: ShoppingListDto): ShoppingListModel = ShoppingListModel(
        id = dto.id,
        name = dto.name,
        items = dto.items.map { itemDto ->
            ShoppingItemModel(
                id = itemDto.id,
                name = itemDto.name,
                category = itemDto.category,
                emoji = itemDto.emoji,
                quantity = itemDto.quantity,
                unit = itemDto.unit?.let { unitDto ->
                    ShoppingItemUnitModel(
                        metric = unitDto.metric?.let { UnitModel(amount = it.amount, unit = it.unit) },
                        imperial = unitDto.imperial?.let { UnitModel(amount = it.amount, unit = it.unit) },
                    )
                },
            )
        },
    )
}
